'use client';
import { ShoppingCart, MessageSquare, Target, DollarSign, Users, Wrench } from 'lucide-react';
import styles from './BentoEcosystem.module.css';

export function BentoEcosystem() {
  return (
    <section className={styles.bentoSection}>
      <div className={styles.bentoHeader}>
        <span className={styles.badge}>O Ecossistema Completo</span>
        <h2 className={styles.title}>Tudo o que sua empresa precisa, em um único painel.</h2>
        <p className={styles.subtitle}>
          Diga adeus a dezenas de abas abertas e mensalidades espalhadas. O Aesir ERP centraliza a sua operação de ponta a ponta com inteligência artificial nativa.
        </p>
      </div>

      <div className={styles.bentoGrid}>
        
        {/* CARD GRANDE: VENDAS & PDV */}
        <div className={`${styles.bentoCard} ${styles.span2col}`}>
          <div className={styles.cardIcon} style={{ background: '#ffedd5', color: '#ea580c' }}>
            <ShoppingCart size={28} />
          </div>
          <h3 className={styles.cardTitle}>Vendas Omnichannel & PDV</h3>
          <p className={styles.cardDesc}>
            Venda no balcão físico, Shopee, Mercado Livre, TikTok Shop e no seu próprio catálogo digital (aesir.shop). O estoque baixa automaticamente em todos os canais.
          </p>
          <ShoppingCart size={180} className={styles.decoration} style={{ bottom: '-30px', right: '-20px', color: '#ea580c' }} />
        </div>

        {/* CARD ALTO: CHAT E IA */}
        <div className={`${styles.bentoCard} ${styles.span2row}`}>
          <div className={styles.cardIcon} style={{ background: '#dbeafe', color: '#2563eb' }}>
            <MessageSquare size={28} />
          </div>
          <h3 className={styles.cardTitle}>Aesir Chat & Agentes IA</h3>
          <p className={styles.cardDesc}>
            Conecte todos os seus números de WhatsApp e Instagram. Deixe nossos robôs de IA atenderem, qualificarem e venderem para seus clientes enquanto você dorme.
          </p>
          <MessageSquare size={160} className={styles.decoration} style={{ bottom: '20px', right: '-30px', color: '#2563eb' }} />
        </div>

        {/* CARD QUADRADO: FINANCEIRO */}
        <div className={styles.bentoCard}>
          <div className={styles.cardIcon} style={{ background: '#dcfce7', color: '#166534' }}>
            <DollarSign size={28} />
          </div>
          <h3 className={styles.cardTitle}>Financeiro & NFe</h3>
          <p className={styles.cardDesc}>Fluxo de caixa, emissão fiscal automática com um clique e gestão de assinaturas recorrentes.</p>
        </div>

        {/* CARD QUADRADO: CRM */}
        <div className={styles.bentoCard}>
          <div className={styles.cardIcon} style={{ background: '#e0f2fe', color: '#0284c7' }}>
            <Users size={28} />
          </div>
          <h3 className={styles.cardTitle}>Funil de Vendas CRM</h3>
          <p className={styles.cardDesc}>Acompanhe negociações em Kanban. Saiba exatamente onde está o seu dinheiro travado.</p>
        </div>

        {/* CARD QUADRADO: CAMPANHAS */}
        <div className={styles.bentoCard}>
          <div className={styles.cardIcon} style={{ background: '#fee2e2', color: '#ef4444' }}>
            <Target size={28} />
          </div>
          <h3 className={styles.cardTitle}>Disparos em Massa</h3>
          <p className={styles.cardDesc}>Faça lançamentos enviando mensagens no WhatsApp sem risco de banimento.</p>
        </div>

        {/* CARD QUADRADO: SERVIÇOS & RH */}
        <div className={styles.bentoCard}>
          <div className={styles.cardIcon} style={{ background: '#fef3c7', color: '#b45309' }}>
            <Wrench size={28} />
          </div>
          <h3 className={styles.cardTitle}>OS & Ponto Digital</h3>
          <p className={styles.cardDesc}>Gere ordens de serviço complexas e faça o controle de ponto geolocalizado da sua equipe.</p>
        </div>

      </div>
    </section>
  );
}